import * as action_types from "./constants";
import { api } from "../../../../services/api"

export const getUserList= () => {
  return async (dispatch) => {

    const response = await api.getAllUsers()

    dispatch({
      type: action_types.GET_USERS,
      data: response?.data,
    });
  };
};

export const getACLGroups= () => {
  return async (dispatch) => {

    const response = await api.getACLGroups()

    dispatch({
      type: action_types.GET_ACL_GROUPS,
      data: response?.data,
    });
  };
};
